import { getVulnerabilitiesByResearcherId } from '@/services';
import type { IQueryParams, VulnerabilityEntry } from '@/types';
import { defineStore } from 'pinia';

type TabKey = 'in-review' | 'validated' | 'published' | 'rejected';

type State = {
  [key in TabKey]: {
    loading: boolean;
    data: VulnerabilityEntry[];
    paginationMetadata: {
      total: number;
      count: number;
      per_page: number;
      current_page: number;
      total_pages: number;
    };
  };
};

export const useVulnerabilitiesStore = defineStore('vulnerabilities', {
  state: (): State => ({
    'in-review': {
      loading: false,
      data: [],
      paginationMetadata: {
        total: 0,
        count: 0,
        per_page: 0,
        current_page: 0,
        total_pages: 0
      }
    },
    validated: {
      loading: false,
      data: [],
      paginationMetadata: {
        total: 0,
        count: 0,
        per_page: 0,
        current_page: 0,
        total_pages: 0
      }
    },
    published: {
      loading: false,
      data: [],
      paginationMetadata: {
        total: 0,
        count: 0,
        per_page: 0,
        current_page: 0,
        total_pages: 0
      }
    },
    rejected: {
      loading: false,
      data: [],
      paginationMetadata: {
        total: 0,
        count: 0,
        per_page: 0,
        current_page: 0,
        total_pages: 0
      }
    }
  }),
  actions: {
    async fetchTabData(uuid: string, tab: TabKey, query: IQueryParams) {
      try {
        this.$state[tab].loading = true;
        const { data } = await getVulnerabilitiesByResearcherId(
          uuid,
          tab,
          query
        );
        this.$state[tab].data = data.value?.data || [];
        this.$state[tab].paginationMetadata = {
          total: data.value?.pagination?.total ?? 0,
          count: data.value?.pagination?.count ?? 0,
          per_page: data.value?.pagination?.per_page ?? 0,
          current_page: data.value?.pagination?.current_page ?? 0,
          total_pages: data.value?.pagination?.total_pages ?? 0
        };
      } catch (err) {
        throw new Error('Error fetching tab data');
      } finally {
        this.$state[tab].loading = false;
      }
    },
    $reset(tab: TabKey) {},
    resetData(tab: TabKey) {}
  }
});
